@use "Styles/includes/variables";

:host {
    box-sizing: border-box;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: variables.$fontQuaternary;
}

*,
*::before,
*::after {
    box-sizing: inherit;
}
